const dtGenerator    = require ('../../../../../components/dt/dt-generator')
const dtHandler      = require ('../../../../../components/dt/dt-handler')
const dtSearch       = require ('../../../../../components/dt/dt-search')
const usersMenu      = require('./users-menu')
const usersDtHandler = require('./users-dt-handler')
const usersDtCommand = require('./users-dt-command')
const {organizeRow}  = require('./users-dt-handler')
const {tableDetail}  = require('./users-dt-handler')
const pageRight      = require('./users-page-right')


/****************ELEMENTS*****************/
var htmlDt          = {}
var HTMLwasSelected = false

function HTMLselect(){ 

      dtHandler.HTMLselect('users-dt', htmlDt, organizeRow, tableDetail)
      HTMLwasSelected  = true
}/**/
/****************ELEMENTS*****************/

export function start(detail){ 

      if (!HTMLwasSelected) {
         // solo ejecutar las funciones de monitor solo si la entidad users esta cargada
         if (obj[detail.elem] != undefined) {
            return;
         }else{
            HTMLselect();
         }
      }

      // si no hay una fincion en act significa que es de las funciones de monitor
      // se estan pasando por el parametro elem las funciones que son de monitor
      if (obj[detail.act] != undefined) {
            obj[detail.act].start(detail)
      }else{
            obj[detail.elem].start(detail)
      }

}/**/

const obj = {
   
      //From fullcont connection    
      addRow:          { start: (detail)=>{  dtGenerator.addRow( detail, htmlDt  )                    }},
      tableOptions:    { start: (detail)=>{  usersMenu.start(detail, htmlDt, 'htmlFc')                }},
      trMenu:          { start: (detail)=>{  usersMenu.start(detail, htmlDt, 'htmlFc')                }},
      updateRow:       { start: (detail)=>{  dtGenerator.updateRow(detail, htmlDt)                    }},

      //data table
      filter:          { start: (detail)=>{  dtSearch.filter(detail, htmlDt )                         }},
      filterShowHide:  { start: (detail)=>{  dtSearch.filterShowHide(detail, htmlDt )                 }},
      loadMore:        { start: (detail)=>{  dtSearch.loadMore(detail, htmlDt )                       }},
      searching:       { start: (detail)=>{  dtSearch.searching(detail, htmlDt, result )                      }},
      select:          { start: (detail)=>{  dtSearch.select(detail, htmlDt, true,select)             }},
      th:              { start: (detail)=>{  dtSearch.th(detail, htmlDt )                             }},
      trPrint:         { start: (detail)=>{  trPrint(detail)                                          }},

      //monitor
      oneJoin:         { start: (detail)=>{  usersDtHandler.lineUpdate(detail.user,htmlDt)            }},
      joinAdminReplay: { start: (detail)=>{  usersDtHandler.joinAdminReplay(detail,htmlDt)            }},
      activityUpdates: { start: (detail)=>{  usersDtHandler.activityUpdates(detail.user.data,htmlDt)  }},
      executeCommand:  { start: (detail)=>{  usersDtCommand.executeCommand(detail,htmlDt)             }},
      leftOne:         { start: (detail)=>{  usersDtHandler.leftOne(detail.user,htmlDt)               }},
      lineCleanAll:    { start: (detail)=>{  usersDtHandler.lineCleanAll(htmlDt)                      }},
      


}/**/

function select(result) {
      usersDtHandler.lastupdateTimer(htmlDt); 
      usersDtHandler.joinAdmin()
      pageRight.start ({act:"createAllChart", result: result  })

      
}

function result(resultComplete){
      usersDtHandler.lastupdateTimer(htmlDt); 
      usersDtHandler.joinAdmin()
}

function trPrint (detail){ console.log(' trPrint>')   }